// removed by extract-text-webpack-plugin
module.exports = {"row":"_-src-components-ReviewStepRow-styles---row---3E_m1","rowLabel":"_-src-components-ReviewStepRow-styles---rowLabel---1l74X","rowValue":"_-src-components-ReviewStepRow-styles---rowValue---2Wv9k"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ReviewStepRow/styles.css
// module id = 779
// module chunks = 0